var map = {
	"./music-instructions.json": 5462,
	"./music-library-intro2024.json": 5463,
	"./music-library-launch2024.json": 5464,
	"./music-progression.json": 5465,
	"./startSourcesAdvanced.json": 5466,
	"./startSourcesSimple.json": 5467,
	"./startSourcesSimple2.json": 5468,
	"./startSourcesTracks.json": 5469
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5029;